// @ts-nocheck
/* eslint-disable */
import { _ } from "~/i18n";
import Scene from "~/scene";
import createSDSIcon from "~/ui/icon";
import { ROUTE_WEATHER } from "~/ui/sds-compatible-icons";
import { icon, node, text } from "~/util/dom";

/**
 * Trida pro vytvoření a ovládání modulu formuláře počasí nad routou
 */
export default class RouteWeatherForm {
	/**
	 * Konstruktor
	 * @param {Object} cb callback metody/funkce
	 */
	constructor(opened, cb) {
		this._routeStart = null;
		this._currentType = "temp";
		this._logger = Mapy.getComponent("logger");
		this._timer = null;
		this._schedule = null;
		this._timeOffset = 0;
		this._actualLocalTime = 0;
		this._opened = opened;
		this._dom = {
			container: node("div", { className: "module-content route-weather" }),
			header: node("div", { className: "route-weather-form-header" }),
			switch: node("input", { type: "checkbox" }),
			indicator: node("span", { className: "indicator", textContent: _("route.weather.off") }),
			types: {
				temp: node("input", { type: "radio", name: "display-type", checked: true, value: "temp" }),
				precip: node("input", { type: "radio", name: "display-type", checked: false, value: "precip" }),
				wind: node("input", { type: "radio", name: "display-type", checked: false, value: "wind" }),
			},
			departuresBox: node("div", { className: "route-weather-form-box" }),
			departureDates: node("select", { className: "departure-date" }),
			departureTime: node("select", { className: "departure-time" }),
			errorBox: node("div", { className: "route-weather-error" }),
		}
		this._isOpen = false;

		this._cb = {
			open: null, //callback po otevření
			close: null //callback po uzavření
		};
		for (let p in cb) {
			this._cb[p] = cb[p];
		}

		this._setIndicator();
		this._build();

		if (Scene.isM3dActive()) {
			this._dom.container.classList.add("disable");
		}

		this._providerListener = Scene.addListener("provider-changed", event => {
			let data = event.data;

			if (data.name == "m3d") {
				this.close();
				this._dom.container.classList.add("disable");
			}
			else {
				this._dom.container.classList.remove("disable");
			}
		});
	}

	/**
	 * Destruktor
	 */
	destroy() {
		Scene.removeListeners(this._providerListener);
		this._cb = {
			open: null, //callback po otevření
			close: null //callback po uzavření
		};
		this._dom.container.remove();
		this._schedule = null;
		this._timeOffset = 0;
		if (this._timer) {
			clearInterval(this._timer);
			this._timer = null;
		}

		this._dom.switch.removeEventListener("change", this, false);
		this._dom.header.removeEventListener("click", this, false);
		this._dom.departureDates.removeEventListener("change", this, false);
		this._dom.departureTime.removeEventListener("change", this, false);
	}

	/**
	 * Zachycení událostí
	 * @param {Event} evt
	 */
	handleEvent(evt) {
		evt.preventDefault();
		let target = evt.target;
		switch (evt.type) {
			case "click": {
				if (target.closest("div.route-weather-form-header") == this._dom.header && !this._dom.container.classList.contains("disable")) {
					this.toggle();
				}
				break;
			}
			case "change": {
				switch (target) {
					case this._dom.switch:
						this.toggle();
						break;
					case this._dom.departureDates:
					case this._dom.departureTime:
						this._runOcb();
						break;
					case this._dom.types.temp:
					case this._dom.types.wind:
					case this._dom.types.precip:
						this._currentType = target.value;
						Object.keys(this._dom.types).forEach(key => {
							this._dom.types[key].removeAttribute("checked");
						});
						target.setAttribute("checked", "");
						if (this._cb.open) {
							this._cb.open({ start: this._routeStart, type: this._currentType });
						}

						this._logger.log("click", {
							text: `type changed to ${this._currentType}`,
							type: "routeWeather"
						});
						break;
				}
				break;
			}
		}
	}

	/**
	 * Zobrazí místo formuláře chybovou hlášku
	 * @param {String} [message = "lang.route.weather.weatherError"] Chybová zpráva k zobrazení
	 */
	setWeatherError(message = _("route.weather.weatherError")) {
		this._dom.departuresBox.remove();
		this._dom.errorBox.textContent = message;
		this._dom.container.appendChild(this._dom.errorBox);
	}

	/**
	 * vrati zpatky formular po chybe
	 */
	resetWeatherError() {
		this._dom.errorBox.remove()
		this._dom.container.appendChild(this._dom.departuresBox);
	}

	/**
	 * Kontejner modulu
	 */
	get container() {
		return this._dom.container;
	}

	/**
	 * vraci aktualni stav
	 * @return {Object} [start, type]
	 */
	get state() {
		this._getCurrentStart();
		return { start: this._routeStart, type: this._currentType, actualLocalTime: this._actualLocalTime };
	}

	/**
	 * nastaveni dat pro vyber dnu a casu
	 * @param  {Object} data [schedule, state]
	 */
	set schedule(data) {
		this._schedule = data.schedule;
		this._timeOffset = data.timeOffset;
		if (this._actualLocalTime == 0) {
			this._actualLocalTime = data.actualLocalTime;
		}
		this._generateDateOptions();
		this._selectDateValue(data.state);
		this._generateTimeOptions();
		// fix - pica IE neni schopna sync veci po sobe - aby nastavila a zrusila selected
		//setTimeout(() => {
		this._selectTimeValue(data.state);
		//}, 0);
	}

	/**
	 * Otevře modul
	 * @param {Object} [start, type] objekt s nastavenim
	 */
	open(data = null) {
		this._dom.container.classList.add("open");
		this._isOpen = true;
		this._setIndicator();

		if (!this._opened) {
			this._logger.log("click", {
				text: "open",
				type: "routeWeather"
			});
		}

		if (data && data.actualLocalTime) {
			this._actualLocalTime = data.actualLocalTime;
		}

		this._generateDateOptions();
		this._selectDateValue(data);
		this._generateTimeOptions();
		this._selectTimeValue(data);

		if (data && "type" in data) {
			let typeKeys = Object.keys(this._dom.types)
			typeKeys.forEach(key => {
				this._dom.types[key].removeAttribute("checked");
				if (this._dom.types[key].value == data.type) {
					this._dom.types[key].setAttribute("checked", "");
					this._dom.types[key].checked = true;
					this._currentType = key;
				}
			});
		}

		this._runOcb(data);
	}

	/**
	 * Zavře modul
	 */
	close() {
		if (!this._isOpen) return;

		this._isOpen = false;

		this._dom.container.classList.remove("open");
		if (this._cb.close) {
			this._cb.close();
		}
		this._setIndicator();

		if (this._timer) {
			clearInterval(this._timer);
			this._timer = null;
		}
		if (this._opened) {
			this._opened = false;
		}

		this._logger.log("click", {
			text: "close",
			type: "routeWeather"
		});
	}

	/**
	 * Přepne otevření modulu
	 */
	toggle() {
		let start = null;
		if (this._getCurrentStart()) {
			start = this._routeStart;
		}
		this._isOpen ? this.close() : this.open({ start, type: this._currentType });
	}

	/**
	 * zobrazeni/skryti loaderu pri nacitani novych dat
	 * @param  {Boolean} show zobrazeni nebo skryti loaderu
	 */
	loader(show = false) {
		this._dom.departuresBox.classList.remove("loading");
		let loader = this._dom.departuresBox.querySelector("p.load");
		if (loader) {
			loader.remove();
		}

		if (show) {
			let loading = node("p", { className: "load", textContent: _("weather.load") });
			this._dom.departuresBox.appendChild(loading);
			this._dom.departuresBox.classList.add("loading");
		}
	}

	/**
	 * Nastaví indikátor otevření nebo zavření v hlavičce modulu
	 */
	_setIndicator() {
		this._dom.switch.checked = this._isOpen;
		this._dom.indicator.textContent = this._isOpen ? _("route.weather.on") : _("route.weather.off");
	}

	/**
	 * Sestaví DOM modul
	 */
	_build() {
		this._dom.header.appendChild(createSDSIcon({ className: "icon-weather", symbol: ROUTE_WEATHER }));
		this._dom.header.appendChild(text(_("route.weather.header")));

		let switchLabel = node("label", { className: "switch" });
		switchLabel.appendChild(this._dom.indicator);
		switchLabel.appendChild(this._dom.switch);
		switchLabel.appendChild(node("span", { className: "slider" }));

		this._dom.header.appendChild(switchLabel);

		let boxType = node("div", { className: "box-type" });
		let tempLabel = node("label", { className: "radiocheck" });
		tempLabel.appendChild(this._dom.types.temp);
		tempLabel.appendChild(node("span", { textContent: _("route.weather.temperature") }));
		let rainLabel = node("label", { className: "radiocheck" });
		rainLabel.appendChild(this._dom.types.precip);
		rainLabel.appendChild(node("span", { textContent: _("route.weather.rain") }));
		let windLabel = node("label", { className: "radiocheck" });
		windLabel.appendChild(this._dom.types.wind);
		windLabel.appendChild(node("span", { textContent: _("route.weather.wind") }));
		boxType.appendChild(tempLabel);
		boxType.appendChild(rainLabel);
		boxType.appendChild(windLabel);

		this._dom.types.temp.addEventListener("change", this, false);
		this._dom.types.precip.addEventListener("change", this, false);
		this._dom.types.wind.addEventListener("change", this, false);

		let boxTime = node("div", { className: "box-time" });
		boxTime.appendChild(node("span", { textContent: _("route.weather.departure") }));
		boxTime.appendChild(this._dom.departureDates);
		boxTime.appendChild(this._dom.departureTime);

		this._dom.departuresBox.appendChild(boxType);
		this._dom.departuresBox.appendChild(boxTime);

		this._dom.container.appendChild(this._dom.header);
		this._dom.container.appendChild(this._dom.departuresBox);

		this._dom.switch.addEventListener("change", this, false);
		this._dom.header.addEventListener("click", this, false);
		this._dom.departureDates.addEventListener("change", this, false);
		this._dom.departureTime.addEventListener("change", this, false);
	}

	/**
	 * oznaceni vybraneho datumu/dne
	 * @param  {Object} data [start]
	 */
	_selectDateValue(data) {
		if (data && "start" in data) {
			let date = null;
			date = new Date();
			date.setTime(data.start * 1000);
			let daySeconds = this._getStartDay(date).getTime() / 1000;
			Array.from(this._dom.departureDates.children).forEach(element => {
				element.removeAttribute("selected");
				element.selected = false;
				if (element.value == daySeconds) {
					element.setAttribute("selected", "");
					element.selected = true;
				}
			});
		}
	}

	/**
	 * oznaceni vybraneho casu
	 * @param  {Object} data [start]
	 */
	_selectTimeValue(data) {
		if (data && "start" in data) {
			let date = null;
			date = new Date();
			date.setTime(data.start * 1000);
			let minuteSeconds = date.getHours() * 3600 + Math.floor(date.getMinutes() / 30) * 1800;

			Array.from(this._dom.departureTime.children).forEach(element => {
				element.removeAttribute("selected");
				element.selected = false;
				if (element.value == minuteSeconds) {
					element.setAttribute("selected", "selected");
					element.selected = true;
				}
			});
		}
	}

	/**
	 * Vygeneruje dny, které můžou zobrazit počasí
	 */
	_generateDateOptions() {
		Mapy.Util.clear(this._dom.departureDates);

		if (this._schedule) {
			let date = this._getStartDay();
			let select = new Date();
			select.setTime(this._routeStart * 1000);
			let daySeconds = this._getStartDay(select).getTime() / 1000;

			this._dom.departureDates.appendChild(node("option", { textContent: _("weather.today"), value: date.getTime() / 1000 }));
			date.setDate(date.getDate() + 1);

			while (date.getTime() / 1000 < this._schedule.lastStamp + this._timeOffset) {
				this._dom.departureDates.appendChild(node("option", { textContent: _(`detail.content.bigDays.nominativ.${date.getDay()}`), value: date.getTime() / 1000 }));
				date.setDate(date.getDate() + 1);
			}
		}

	}

	/**
	 * Vygeneruje hodiny pro vybraný den, které můžou zobrazit počasí
	 */
	_generateTimeOptions() {
		Mapy.Util.clear(this._dom.departureTime);

		if (this._schedule) {
			let selectedFor = "", latest = null, isNotSelected = true;
			let dayValue = parseInt(this._dom.departureDates.value) || 0;

			if (this._timer) {
				clearInterval(this._timer);
				this._timer = null;
			}

			//dnes
			if (this._dom.departureDates.selectedIndex == 0) {
				let now = Math.floor(this._actualLocalTime / 1000);
				let secondsOver = now % 1800;
				let day = (new Date(this._actualLocalTime)).getDay();

				latest = new Date();
				latest.setTime((now + 1800 - secondsOver) * 1000);
				this._timer = setInterval(() => { this._checkTime(); }, 1000 * 60 * 10);
				let option = node("option", { textContent: _("route.weather.now"), value: "now" });

				this._dom.departureTime.appendChild(option);

				if (day != latest.getDay()) {
					return;
				}
			} else {
				latest = this._getStartDay();
				selectedFor = "10:00";
			}

			let day = latest.getDay();

			while (latest.getDay() == day) {
				let value = latest.getHours() * 3600 + latest.getMinutes() * 60;
				let h = latest.getHours() < 10 ? "0" + latest.getHours() : latest.getHours();
				let m = latest.getMinutes() < 10 ? "0" + latest.getMinutes() : latest.getMinutes();

				if (dayValue + value < this._schedule.lastStamp + this._timeOffset) {
					let time = `${h}:${m}`;
					let option = node("option", { textContent: time, value: value });

					if (selectedFor && selectedFor == time) {
						option.setAttribute("selected", "");
						isNotSelected = false;
					}

					this._dom.departureTime.appendChild(option);
					latest.setMinutes(latest.getMinutes() + this._schedule.step / 60);
				} else {
					latest.setMinutes(24 * 60);
				}

			}

			if (selectedFor && isNotSelected) {
				this._dom.departureTime.lastChild.setAttribute("selected", "");
			}
		}
	}

	/**
	 * Vrátí den a čas, odpovídající počátku dne
	 * @param {Date} [startDate = null] Datum, který chci použít, jinak to bude dnes
	 * @returns {Date} Datum a čas nastavený na počátek daného dne
	 */
	_getStartDay(startDate = null) {
		let date = new Date(this._actualLocalTime);
		if (startDate) { date.setTime(startDate.getTime()); }
		date.setHours(0);
		date.setMinutes(0);
		date.setSeconds(0);
		date.setMilliseconds(0);
		date.setTime(date.getTime());
		return date;
	}

	/**
	 * Z nastavených hodnot vypočítá čas odjezdu v sekundách, při neúspěchu nechá starý
	 * @returns {Boolean} Úspěch, změna provedena
	 */
	_getCurrentStart() {
		if (this._dom.departureDates.selectedIndex == 0 && this._dom.departureTime.value == "now") {
			this._routeStart = null;
			return true;
		}
		else {
			let now = Math.floor(Date.now() / 1000 + this._timeOffset);
			let secondsOver = now % 1800;
			let latest = new Date();
			latest.setTime((now + 1800 - secondsOver) * 1000);
			let daySeconds = parseInt(this._dom.departureDates.value);
			let hourSeconds = this._dom.departureTime.value == "now" ? latest.getHours() * 3600 + latest.getMinutes() * 60 : parseInt(this._dom.departureTime.value);

			if (typeof daySeconds == "number" && typeof hourSeconds == "number") {
				this._routeStart = daySeconds + hourSeconds;

				if (this._routeStart < now) {
					this._routeStart = Math.ceil(Date.now() / 1000 + this._timeOffset);
				}

				return true;
			}
		}

		return false;
	}

	/**
	 * Spustí callback funkci pro otevření
	 */
	_runOcb(data) {
		if (this._cb.open) {
			if (!data) {
				this._getCurrentStart();
			}
			this._cb.open(data || { start: this._routeStart, type: this._currentType, actualLocalTime: this._actualLocalTime });
		}
	}

	/**
	 * Pro dnešní den kontroluje nejmenší časy, zdali se dají ještě použít, jinak je odstraní
	 */
	_checkTime() {
		let dayValue = parseInt(this._dom.departureDates.value);
		let now = Math.floor(Date.now() / 1000);
		let regenerate = false;

		Array.from(this._dom.departureTime.children).forEach((item, index) => {
			if (item.value != "now" && dayValue + parseInt(item.value) < now - 30 * 60) {
				if (this._dom.departureTime.selectedIndex == index) {
					regenerate = true;
				}
				item.remove();
			}
		});
		if (regenerate) {
			this._runOcb();
		}
	}
}
